import React, { useEffect, useState } from 'react'
import {
  useHistory,
  useLocation,
  useParams,
  withRouter,
} from 'react-router-dom'
import { routes } from '../../../constantes/routes'
import ProductsPresentationList from '../edit-presentation/ProductsPresentationList'
import { presentationProductsApi } from '../../../api/presentationsApi'
import { articlesApi } from '../../../api/articlesApi'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
  swalLoading,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import { CgShoppingCart } from 'react-icons/cg'
import Header from '../../header/Header'
import PlusBtn from '../../buttons/PlusBtn'
import _ from 'lodash'
import '../../../assests/styles/catalogue/catalogueButtons.scss'
import FinalProductContainer from '../../final-product/FinalProductConainer'
import { useDispatch, useSelector } from 'react-redux'
import { presentationsActions } from '../../../actions/presentationsActions'
import SendBtn from '../../buttons/SendBtn'

const EditPresentationContainer = () => {
  const { id } = useParams()
  const history = useHistory()
  let location = useLocation()
  const dispatch = useDispatch()

  const [namePresentation, setNamePresentation] = useState('')
  const [allPresentationProducts, setAllPresentationProducts] = useState([])
  const [cartItemsCounter, setCartItemsCounter] = useState(0)
  const [presentation, setPresentation] = useState(null)
  const userProfile = useSelector((state) => state.userProfile)
  const presentationsState = useSelector((state) => state.presentations)
  const [isDisabled, setIsDisabled] = useState(false)
  const [isfinalProductView, setFinalProductView] = useState(false)
  const [itemSelected, setItemSelected] = useState('')

  const [contactLgpdResponse, setContactLgpdResponse] = useState(null);

  useEffect(() => {
    const presentationFiltered = presentationsState.filter(
      (presentation) => presentation.id_Presentacion === parseInt(id),
    )
    setPresentation(presentationFiltered[0])
  }, [presentationsState, id])

  useEffect(() => {
    getPresentationById(id)
  }, [isfinalProductView])

  //------------ GET ALL INFO PRESENTATION --------------
  const getPresentationById = async (getPresentationById) => {
    try {
      let response =
        await presentationProductsApi.getInfoProductsPresentationById(
          getPresentationById,
        )

      if (response.data) {
        setNamePresentation(response.data.nombre)
        setCartItemsCounter(response.data.numeroProductosPresentacion)
        setAllPresentationProducts(response.data.productos)
        setContactLgpdResponse(response.data.contactos[0].id_RespuestaLgpd);
      }
    } catch (error) {
      history.push(routes.PRESENTATION)
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  //-------------   Producto final --------------
  // Eliminar producto final, elimina los docuemntos articulo añadidos en la presentacion
  const handleRemovePresentationProduct = async (idArticle) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar el producto de la presentación?',
      )
      if (alert.isConfirmed) {
        const response =
          await presentationProductsApi.deletePresentationProduct(id, idArticle)
        setAllPresentationProducts(
          allPresentationProducts.filter(
            (item) => item.id_Articulo !== idArticle,
          ),
        )
        await swalSuccessGeneral(swalTitle.Eliminado, response.data)
        setCartItemsCounter(cartItemsCounter - 1)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }
  // Editar producto final
  const toEditPresentationProduct = (idProduct) => {
    getInfoProduct(idProduct)
    history.push(location.pathname + '/editProduct/' + idProduct) // para diferenciar cuando estamos en un producto final visualizando los documentos
    setFinalProductView(true)
  }

  // Visualizar la informacion del producto
  const getInfoProduct = async (id_Article) => {
    const response = await articlesApi.getInfoArticle(id_Article)
    setItemSelected(response.data)
  }

  //Click añadir producto a la presentacion
  const addNewProduct = (e) => {
    e.preventDefault()
    history.push(routes.PRESENTATION_ADD_PRODUCTS + id)
  }

  const goBack = () => {
    isfinalProductView
      ? history.push(routes.PRESENTATION_EDIT + id)
      : history.push(routes.PRESENTATION)
    setFinalProductView(false)
  }

  const handleSendPresentationToContact = async (id_ContactoPresentacion) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres enviar la presentación?',
      )
      if (alert.isConfirmed) {
        swalLoading(swalTitle.Loading)
        setIsDisabled(true)
        const response = await dispatch(
          presentationsActions.sendPresentationToContact(
            id_ContactoPresentacion,
          ),
        )
        if (response.payload) {
          swalSuccessGeneral(swalTitle.Enviado, response.payload.mssg)
        }
        setIsDisabled(false)
      }
    } catch (error) {
      swalAlertError(error.payload)
      setIsDisabled(false)
    }
  }
  const canEditDeleteSendPresentation = (presentation) => {
    return presentation.id_Usuario === userProfile.id_Usuario
  }

  // Prohibido: No se permite modificar esta sección.
  return (
    <div className='products'>
      <Header text={'Editar presentación'} route={goBack} backBtn={true} />

      <div className='filter__wrap-left mb-80'>
        <h4 className='products__route' style={{ textTransform: 'inherit' }}>
          Productos de {namePresentation}
          {
            contactLgpdResponse === 2 &&
              <div style={{ color: 'red' }}>
                El usuario rechazó la LGPD.
              </div>
          }
        </h4>
        <div className='add__action__rigth__side' style={{ marginRight: '10rem'}}>
          {!isfinalProductView ? (
            <button
            style={{ minWidth: '200px'}}
              onClick={(e) => addNewProduct(e)}
              className='action-button'
            >
              <PlusBtn />
              <span>Añadir productos</span>
            </button>
          ) : null}

          {presentation?.presentacionContacts?.length > 0 ? (
            canEditDeleteSendPresentation(presentation) &&
            presentation?.presentacionContacts[0]?.isActive ? (
              <button
                className="action-button"
                disabled={isDisabled}
                style={ contactLgpdResponse === 2 ? { opacity: 0.4, cursor: 'disabled', pointerEvents: 'none' } : {} }
                onClick={() => {
                  if (presentation?.presentacionContacts[0]) {
                    handleSendPresentationToContact(
                      presentation?.presentacionContacts[0]
                        ?.id_ContactoPresentation,
                    )
                  }
                }}
              >
                <SendBtn />
              </button>
            ) : null
          ) : null}
        </div>
        <span className='btn-add-shopping' style={{ opacity: 0.4, cursor: 'disabled', pointerEvents: 'none' }}>
          <span className='cart-counter'>{cartItemsCounter}</span>
          <span>
            <CgShoppingCart className='green-btn-plus cart-btn' />
          </span>
        </span>
      </div>
      <hr />
      {isfinalProductView ? (
        <div className='frameless'>
          <FinalProductContainer
            item={itemSelected}
            idPresentation={id}
            isEditProductPresentation={true}
          />
        </div>
      ) : (
        <div className='products__cards-list-wrapper'>
          <ProductsPresentationList
            isEditPresentation={true}
            allPresentationProducts={allPresentationProducts}
            handleRemovePresentationProduct={handleRemovePresentationProduct}
            toEditPresentationProduct={toEditPresentationProduct}
          />
        </div>
      )}
    </div>
  )
}
export default withRouter(EditPresentationContainer)
